// extracted by mini-css-extract-plugin
module.exports = {"sectionForm":"PersonalData_sectionForm__32FBY","formLabel":"PersonalData_formLabel__2zvph"};